
import Vue from 'vue'
export default Vue.extend({
  data() {
    return {
      floatHeight: 0,
    }
  },
  mounted() {
    const floatBarDom = this.$refs.floatBar as HTMLDivElement
    this.floatHeight = floatBarDom.clientHeight
  },
})
